export default __webpack_public_path__ + "static/media/immunity.728717b1.svg";